import React, { createContext, useContext, useMemo } from "react";

// No backend endpoint exists yet for subscriptions/billing, so this is an
// honest stub: nobody is ever "subscribed" until that's built.
const defaultSubscriptionValue = {
  products: [],
  customerInfo: null,
  isSubscribed: false,
  isLoading: false,
  isInitialized: true,
  error: null,
};

const SubscriptionContext = createContext(defaultSubscriptionValue);

export const SubscriptionProvider = ({ children }) => {
  const value = useMemo(() => defaultSubscriptionValue, []);

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => useContext(SubscriptionContext);
